import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(12),
    background: '#fff',
    borderRadius: spacing(8),
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    padding: spacing(12),
    cursor: 'pointer',
    border: '1px solid #e0e0e0',
    transition: 'box-shadow 0.2s',
    maxHeight: spacing(164),

    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    },

    '&:active': {
      cursor: 'move',
    },
  },
  spacedSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  itemWithIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(4),
  },
  addressRow: {
    alignItems: 'flex-start',
  },
  addressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    gap: spacing(4),
  },
  itemText: {
    fontSize: spacing(12),
    lineHeight: spacing(12),
    color: Theme.Colors.Grayscale.SixtyFour,
  },
  ellipsisSingleLine: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
  ellipsisDoubleLine: {
    lineHeight: 1.3,
    overflow: 'hidden',

    // WebKit clamp (Chrome/Edge/Safari/Opera)
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,

    // Fallback para navegadores sem suporte (ex.: Firefox)
    '@supports not (-webkit-line-clamp: 2)': {
      display: 'block',
      maxHeight: 'calc(1.3em * 2)',
    },
  },
  categoryText: {
    fontSize: spacing(16),
    fontWeight: 700,
  },
  bold: {
    fontWeight: 700,
  },
  icons: {
    height: spacing(12),
    width: spacing(12),
    minWidth: spacing(12),
    fill: Theme.Colors.Grayscale.SixtyFour,
  },
  priorityWrapper: {
    height: spacing(12),
    width: spacing(12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  whatsappButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#21C063',
    padding: spacing(4),
    borderRadius: spacing(4),
    cursor: 'pointer',
    transition: 'background 0.2s',
    textDecoration: 'none',
    height: spacing(24),
    width: spacing(24),

    '&:hover': {
      background: '#1ebe57',
    },
  },
  whatsappIcon: {
    fontSize: spacing(16),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(8),
  },
}))
